import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {
  ButtonToolbar,
  ButtonGroup,
  Button,
  Badge,
  MenuItem,
  DropdownButton,
} from 'react-bootstrap';

const currencyOptions = [
	{
      label: 'All',
      value: '',
    },
    {
      label: '🇦🇺 AUD - Australian Dollar',
      value: 'AUD',
    },
    {
      label: '🇨🇦 CAD - Canadian Dollar',
      value: 'CAD',
    },
    {
      label: '🇨🇳 CNY - Chinese Yuan Renminbi',
      value: 'CNY',
    },
    {
      label: '🇪🇺 EUR - Euro',
      value: 'EUR',
    },
    {
      label: '🇬🇧 GBP - British Pound',
      value: 'GBP',
    },
    {
      label: '🇯🇵 JPY - Japanese Yen',
      value: 'JPY',
    },
    {
      label: '🇲🇽 MXN - Mexican Peso',
      value: 'MXN',
    },
    {
      label: '🇺🇸 USD - US Dollar',
      value: 'USD',
    },
    {
      label: '🇳🇿 ZND - New Zealand Dollar',
      value: 'ZND',
    },
    {
      label: '🇧🇷 BRL - Brazilian Real',
      value: 'BRL',
    },
    {
      label: '🇦🇷 ARS - Argentinian peso',
      value: 'ARS',
    },
    {
      label: '🇨🇱 CLP - Chilean Peso',
      value: 'CLP',
    },
    {
      label: '🇩🇰 DKK - Danish Krone',
      value: 'DKK',
    },
    {
      label: '🇮🇳 INR - Indian Rupee',
      value: 'INR',
    },
    {
      label: '🇰🇷 KRW - Korean Won',
      value: 'KRW',
    },
    {
      label: '🇳🇴 NOK - Norwegian Krone',
      value: 'NOK',
    },
    {
      label: '🇷🇺 RUB - Russian Ruble',
      value: 'RUB',
    },
    {
      label: '🇨🇭 CHF - Swiss Franc',
      value: 'CHF',
    },
  ];

function formatButtonGroup(buttons, group, groupName, currencyFilter, setFilter) {
  const isSet = currencyFilter ? (currencyFilter[group] == true) : false;
  const indicator = isSet ? (<i className="fa fa-check-square-o" aria-hidden="true" />):  (<i className="fa fa-square-o" aria-hidden="true" />);
  // const style = { color: GROUP_COLORS[group % 4] };
  // const colorSwatch = (<i className="fa fa-square fa-2x" aria-hidden="true" style={style} />);

  buttons.push(
    (<MenuItem
      key={group}
      onClick={setFilter}
      data-item={group}
      data-value={group}
    >{indicator} {groupName}</MenuItem>),
  );
}

export class CommissionCurrencyFilter extends React.Component {
  constructor(props) {
    super(props);
    this.setFilter = this.setFilter.bind(this);    
    this.props.currencyFilterSet({USD: true}, 'USD');
  }
  setFilter = (e) => {
    const filterType = e.currentTarget.getAttribute('data-item');
    const filterValue = e.currentTarget.getAttribute('data-value') === 'true';
    const newFilter = {};
    // TOGGLE the filter values
    newFilter[filterType] = !filterValue;
    this.props.currencyFilterSet(newFilter, filterType);
    // $("#bg-nested-dropdown").click(function(e){
    //   e.stopPropagation();
    // })
  }
  render() {
  	try{
  		const buttons = [];
      	const groupButtons = [];
  		// const count = Object.keys(this.props.filter).length;
  		const title = <span><i className="fa fa-filter" aria-hidden="true" /> Filter</span>;
		currencyOptions.forEach((currency) => {
		    formatButtonGroup(buttons, currency.value, currency.label, this.props.currencyFilter, this.setFilter);
		 });
		return (	       
            <DropdownButton title={title} id="bg-nested-dropdown" bsStyle="info" drop="end">
              {buttons}
            </DropdownButton>
	    );
  	}catch (e) {
      console.log("EventFilter -> ", e);
      return null;
    }
  }
}

CommissionCurrencyFilter.propTypes = {
  currencyFilter: PropTypes.object.isRequired,
  currencyFilterSet: PropTypes.func.isRequired,
};

export default CommissionCurrencyFilter;


// WEBPACK FOOTER //
// src/routes/commissions/components/CommissionCurrencyFilter.js